import React, { useCallback, useState } from "react";
import styled from "styled-components";
import Icon from "../Icon/Icon";

interface IProps {
    children: React.ReactNode;
    textName: string;
    onClick?: () => void;
}

const StyledGroupedItem = styled.ul<{ isOpen: boolean }>`
    border: none;
    border-bottom: 1px solid ${(props) => props.theme.colors.neutral.neutral50};
    cursor: pointer;
    display: block;

    div {
        align-items: center;
        display: flex;
        justify-content: space-between;
        min-height: 40px;
        padding: ${(props) => props.theme.spacing.xs};
        :active {
            font-weight: bold;
        }
        svg {
            transform: ${({ isOpen }) => (isOpen ? "rotate(90deg)" : "none")};
        }
    }

    p {
        font-size: ${(props) => props.theme.typography.body.medium.fontSize};
        margin: 0;
    }

    li {
        color: ${(props) => props.theme.colors.neutral.neutral400};
        padding: ${(props) => props.theme.spacing.xs};
        padding-left: ${(props) => props.theme.spacing.md};
    }

    li a {
        color: ${(props) => props.theme.colors.neutral.neutral400};
        text-decoration: none;

        &:hover {
            text-decoration: none;
        }
    }
`;

const GroupedItem = ({ children, textName, onClick }: IProps) => {
    const [isOpen, setIsOpen] = useState(true);

    const onArrowClick = useCallback(() => {
        setIsOpen((state) => !state);
    }, []);

    return (
        <StyledGroupedItem isOpen={isOpen}>
            <div>
                <p onClick={onClick}>{textName}</p>
                <Icon
                    onClick={onArrowClick}
                    iconPath="ArrowRight"
                    colorVariant="neutral.neutral400"
                />
            </div>
            {isOpen && children}
        </StyledGroupedItem>
    );
};

export default GroupedItem;
